export default __webpack_public_path__ + "static/media/chicken-soup.bc2c0bcc.jpeg";